import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudIconModule,
	FreudTagModule,
	FreudTooltipModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { DetailsContactInfoModule } from 'app/appointments/details-contact-info/details-contact-info.module';

import { AppointmentDetailsHeaderComponent } from './appointment-details-header.component';

@NgModule({
	declarations: [AppointmentDetailsHeaderComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudTypographyModule,
		FreudTagModule,
		DetailsContactInfoModule,
		FreudIconModule,
		FreudTooltipModule,
	],
	exports: [AppointmentDetailsHeaderComponent],
})
export class AppointmentDetailsHeaderModule {}
